import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Link,
  useLocation,
  useMatch,
  useMatches,
  useLoaderData,
} from "react-router-dom";
import { useMediaQuery } from "react-responsive";
const SectionSix = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  return (
    <div
      className={
        isMobile ? "section-six-pricing-mob" : "section-six-pricing-inter"
      }
    >
      <div style={{ maxWidth: "600px" }}>
        <h1 className="sec-six-heading-pricing-inter">
          Start Driving Retention Today
        </h1>
        <p
          style={{
            fontSize: !isMobile ? "24px" : "15px",
            color: "black",
            padding: isMobile && "20px",
          }}
        >
          Choose your plan, grow your revenue, and delight your customers with
          Kwik Engage. Join leading D2C brands who are already transforming
          their customer relationships.
        </p>
        <div className="pricing-btn-grp">
          <a
            href="https://apps.shopify.com/kwikengage?utm_source=pricingpage&utm_medium=shopify"
            target="_blank"
            style={{ color: "black" }}
          >
            {" "}
            <button className="cta1a-install-shoppy">
              Install Free Shopify App
            </button>
          </a>
          <Link to="/contact" style={{ color: "black" }}>
            <div className="cta1a-Ind-price">Talk to Sales</div>
          </Link>
        </div>
      </div>
      <div>
        <img
          className="aim-image"
          src="assets/images/kwikpricing/aim.png"
          alt=""
        />
      </div>
    </div>
  );
};

export default SectionSix;
